module.exports = __webpack_public_path__ + "img/GFilm.430755bf.gif";